<template>
  <div class="analysis">
    <a-row>
      <a-col :span="24">
        <div class="serach-container">

          <a-button-group class="btn-group">
            <a-button @click="todaybtn" :type="todayp">今天</a-button>
            <a-button @click="yesterdaybtn" :type="yesterdayp">昨天</a-button>
            <a-button @click="sevenbtn" :type="sevenp">最近7天</a-button>
            <a-button @click="monthbtn" :type="monthp">最近30天</a-button>
          </a-button-group>
           <a-range-picker style="width:256px" @change="onChange" :locale="locale"/>
          <a-button type="primary" @click="dataquery">查询</a-button>
        </div>
      </a-col>
    </a-row>

    <div class="analysis-top-data">
      <a-card>
        <a-row >
          <a-col :span="4">
            <div class="title">
              <span>浏览次数</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>即通常说的Page View(PV),用户每打开一个网站页面就被记录1次。用户多次打开同一页面，累计记录。</span>
                </template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
            <p>{{toptotal.total}}</p>
          </a-col>
          <a-col :span="4">
            <div class="title">
              <span>IP数</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>某一段时间之内,访问网站的不重复的IP数。这一段时间之内相同IP地址多次访问网站只被计算一次。</span>
                </template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
            <p>{{toptotal.ip}}</p>
          </a-col>
          <a-col :span="4">
            <div class="title">
              <span>扣费次数</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span> 即有效IP,某一段时间之内,每一天付费IP的数量的累计总和。 </span>
                </template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
            <p>{{toptotal.cumcount}}</p>
          </a-col>
          <a-col :span="4">
            <div class="title">
              <span>新独立访客</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span>  某一段时间之内,历史上首次访问网站的访客为新独立访客。  </span>
                </template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
            <p>{{toptotal.user}}</p>
          </a-col>
          <a-col :span="4">
            <div class="title">
              <span>人均浏览页数</span>
              <a-tooltip placement="top">
                <template slot="title">
                  <span> 人均浏览页数=浏览次数/IP </span>
                </template>
                <a-icon type="exclamation-circle" />
              </a-tooltip>
            </div>
            <p>{{toptotal.percent}}</p>
          </a-col>
          <a-col :span="4">
            <div class="title">
              <span>消费金额(元)</span>
            </div>
            <p>{{toptotal.totalmoney}}</p>
          </a-col>
        </a-row>
      </a-card>
    </div>

    <div class="analysis-middle-data">
      <a-row :gutter="22" style="margin-bottom:24px">
        <a-col :span="12">
          <a-card>
            <div class="tab-list">
              <a-radio-group name="radioGroup" :default-value="1" @change="changeflowsource">
                <a-radio :value="1">
                  浏览次数
                </a-radio>
                <a-radio :value="2">
                  IP
                </a-radio>
                <a-radio :value="3">
                  有效IP
                </a-radio>
              </a-radio-group>
            </div>

            <a-spin :spinning="spinning">
              <div class="spin-content">
                <div id="weightChart" style="width: 100%;height:400px;"></div>
              </div>
            </a-spin>

         
          </a-card>
        </a-col>
        <a-col :span="12">
           <a-card>
            <div class="tab-list">
              <a-radio-group name="radioGroup" :default-value="1" @change="changeTop">
                <a-radio :value="1">
                  浏览次数
                </a-radio>
                <a-radio :value="2">
                  IP
                </a-radio>
                <a-radio :value="3">
                  有效IP
                </a-radio>
              </a-radio-group>
            </div>

            <a-spin :spinning="spinning">
              <div class="spin-content">
                <!-- 流量区域TOP10 -->
                <div id="areaChart" style="width: 100%;height:400px;"></div>
              </div>
            </a-spin>
          </a-card>
        </a-col>
      </a-row>

       <a-row :gutter="22" style="margin-bottom:24px">
        <a-col :span="12">
          <a-card>
            <a-spin :spinning="spinning">
              <div class="spin-content">
                <!-- 流量趋势图 -->
                <div id="trendChart" style="width: 100%;height:400px;"></div>
              </div>
            </a-spin>
          </a-card>
        </a-col>
        <a-col :span="12">
           <a-card>
            <a-spin :spinning="spinning">
              <div class="spin-content">
                <!-- 有效IP走势图 -->
                <div id="useIPChart" style="width: 100%;height:400px;"></div>
              </div>
            </a-spin>
          </a-card>
        </a-col>
      </a-row>
    </div>

    <!-- 流量报表 -->
      <a-card title="流量报表" class="traffic-report">

        <a-table
          :columns="columns"
          :pagination="pagination"
          :loading="loading"
          @change="handleTableChange"
          :data-source="data"
          :locale="locale"
        >
        </a-table>

      </a-card>
  </div>
</template>

<script>

const columns = [
  {
    title: 'ID',
    dataIndex: 'id',
    key: 'id',
    // scopedSlots: { customRender: 'name' },
  },
  {
    title: '访问日期',
    dataIndex: 'create_time',
    key: 'create_time',
    sorter: (a, b) => a.create_time - b.create_time,
    sortDirections: ['desc', 'asc'],
    width:120
  },
  {
    title: '流量类型',
    dataIndex: 'typestr',
    key: 'typestr',
    filters: [
    ],
    filterMultiple: false,
  },
  {
    title: '流量来源',
    key: 'source',
    dataIndex: 'source',
    filters: [
    ],
    filterMultiple: false,
  },
    {
    title: 'IMEI',
    key: 'imei',
    dataIndex: 'imei',
  },
  {
    title: '推广词',
    key: 'keyword',
    dataIndex: 'keyword',
    width:120
  },
  {
    title: '受访URL',
    key: 'url',
    dataIndex: 'url',
    width: 340,
  },
  {
    title: '地区',
    key: 'ip',
    dataIndex: 'ip',
    width:180
  },
  {
    title: '消费金额（元）',
    key: 'price',
    dataIndex: 'price',
  },
];


import locale from 'ant-design-vue/es/date-picker/locale/zh_CN';
let echarts = require('echarts/lib/echarts');
require('echarts/lib/chart/bar')
require('echarts/lib/chart/pie')
require('echarts/lib/chart/line')
// 引入提示框和title组件，图例
require('echarts/lib/component/tooltip')
require('echarts/lib/component/title')
require('echarts/lib/component/legend')
require('echarts/lib/component/legendScroll')//图例滚动
export default {
  data () {
    return {
      locale,
      todayp:'primary',
      yesterdayp:'',
      sevenp:'',
      monthp:'',
      folwsource:[],
      spinning:false,
      data:[],
      columns,
      pagination: {},
      loading: false,

      flowtrendx:"",
      flowtrendy:"",
      uiptrendx:"",
      uiptrendy:"",
      flowtop10x:"",
      flowtop10y:"",
      flowsourcex:"",
      flowsourcey:"",
      changesource:1,

      qdate:"",
      start_time:"",
      end_time:"",
      toptotal:"",
      flowtop10xwidth:"",
      kind:1


    }
  },
  mounted(){
    this.start_time=this.getDay(0)
    this.end_time=this.getDay(0)
    var params=new URLSearchParams()
    params.append('limits',20)
    params.append('page',1)

    // 汇总
    this.$axios.get("/api/folwtotalstatic",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
        }
    }).then((res)=> {

        if(res.data.code==200){
          this.toptotal=res.data.data
     
        }else if(res.data.code==300){
            this.$router.push({path: '/'})
        }else{
            Toast(res.data.msg)
        }
    })

    var that=this
    this.fetch()



    // 流量来源
    this.$axios.get("/api/getflowsource",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
    }).then((res)=> {
        if(res.data.code==200){
          var list=JSON.parse(JSON.stringify(res.data.data).replace(/name/g, 'text'));
          list=JSON.parse(JSON.stringify(list).replace(/id/g, 'value'));
          for(var i in list){
            list[i].value=list[i].value+''
          }
          this.columns[3].filters  = list
        }else if(res.data.code==300){
            this.$router.push({path: '/'})
        }else{
            Toast(res.data.msg)
        }
    })

    // 流量类型
    this.$axios.get("/api/getflowtype",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
    }).then((res)=> {
        if(res.data.code==200){
          var list=JSON.parse(JSON.stringify(res.data.data).replace(/name/g, 'text'));
          list=JSON.parse(JSON.stringify(list).replace(/id/g, 'value'));
          for(var i in list){
            list[i].value=list[i].value+''
          }
          this.columns[2].filters  = list
        }else if(res.data.code==300){
            this.$router.push({path: '/'})
        }else{
            Toast(res.data.msg)
        }
    })

    // 流量趋势
    this.$axios.get("/api/flowtop10",{
      headers:{
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
      },
      params:{
        end_time:this.end_time,
        start_time:this.start_time,
        kind:this.kind
      }
    }).then((res)=> {
      if(res.data.code==200){
        var num=res.data.data.count
        var width=(400/num)-10
        this.flowtop10xwidth=width
        console.log("width="+num)
        console.log("flowtop10xwidth="+this.flowtop10xwidth)
        this.flowtop10x=res.data.data.xstr
        this.flowtop10x= eval('(' +  this.flowtop10x + ')');
        this.flowtop10y=res.data.data.ystr
        this.flowtop10y= eval('(' +  this.flowtop10y + ')');
        this.drawLine();
      }
    })

    // 流量来源比重
    this.$axios.get("/api/flowsource",{
      headers:{
          "appid": this.appSet.appid,
          "appkey": this.appSet.appkey,
          "token":localStorage.getItem('token'),
      },
      params:{
        end_time:this.end_time,
        start_time:this.start_time,
      }
    }).then((res)=> {
      if(res.data.code==200){
        this.flowsourcex=res.data.data.sourcestr
        this.flowsourcex = this.flowsourcex.replace(/'/g, '"');
        this.flowsourcex=JSON.parse(this.flowsourcex);
        this.flowsourcey=res.data.data.browstr
        this.flowsourcey = this.flowsourcey.replace(/'/g, '"');
        this.flowsourcey=JSON.parse(this.flowsourcey);
        var obj=[]
        for(var i in this.flowsourcex ){
          obj.push({name:this.flowsourcex[i],value:this.flowsourcey[i]});
        }
        obj=JSON.stringify( obj )
        this.flowsourcey= eval('(' +  obj + ')');
        this.drawLine();
      }
    })

    this.drawLine();
  },
  methods:{
    // 日期查询
    dataquery(){
      var qdate=this.qdate
      this.start_time=qdate[0]
      this.end_time=qdate[1]
      this.fetch()
      this.querdata()
    },
    // 今天查询
    todaybtn(){
      this.start_time=this.getDay(0)
      this.end_time=this.getDay(0)
      this.fetch()
      this.querdata()
      this.todayp="primary"
      this.yesterdayp=''
      this.sevenp=''
      this.monthp=''
    },
    // 昨天查询
    yesterdaybtn(){
      this.todayp=""
      this.yesterdayp='primary'
      this.sevenp=''
      this.monthp=''
      this.start_time=this.getDay(-1)
      this.end_time=this.getDay(-1)
      this.fetch()
      this.querdata()
     
    },
    // 最近7天
    sevenbtn(){
      this.todayp=""
      this.yesterdayp=''
      this.sevenp='primary'
      this.monthp=''
      this.start_time=this.getDay(-7)
      this.end_time=this.getDay(0)
      this.fetch()
      this.querdata()
      
    },
    // 最近30天
    monthbtn(){
      this.todayp=""
      this.yesterdayp=''
      this.sevenp=''
      this.monthp='primary'
      this.start_time=this.getDay(-30)
      this.end_time=this.getDay(0)
      this.fetch()
      this.querdata()
    },
    // 获取当前日期
    getDay(day) {　　
      var today = new Date();　　
      var targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;　　
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      　　
      var tYear = today.getFullYear();　　
      var tMonth = today.getMonth();　　
      var tDate = today.getDate();　　
      tMonth = this.doHandleMonth(tMonth + 1);　　
      tDate = this.doHandleMonth(tDate);　　
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {　　
        var m = month;　　
        if (month.toString().length == 1) {　　
            m = "0" + month;　　
        }　　
        return m;
    },

    // TOP10单选切换
    changeTop(e){
      var changesource=e.target.value;
      this.kind=changesource
         // 流量趋势
      this.$axios.get("/api/flowtop10",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
          kind:this.kind
        }
      }).then((res)=> {
        if(res.data.code==200){
          var num=res.data.data.count
          var width=(400/num)-10
          this.flowtop10xwidth=width
            console.log("width="+num)
          console.log("flowtop10xwidth="+this.flowtop10xwidth)
          this.flowtop10x=res.data.data.xstr
          this.flowtop10x= eval('(' +  this.flowtop10x + ')');
          this.flowtop10y=res.data.data.ystr
          this.flowtop10y= eval('(' +  this.flowtop10y + ')');
          this.drawLine();
        }
      })
    },


    querdata(){
       // 汇总
        this.$axios.get("/api/folwtotalstatic",{
            headers:{
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
              end_time:this.end_time,
              start_time:this.start_time,
            }
        }).then((res)=> {

            if(res.data.code==200){
              this.toptotal=res.data.data
        
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else{
                Toast(res.data.msg)
            }
        })

        // 流量来源
      this.$axios.get("/api/getflowsource",{
          headers:{
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
      }).then((res)=> {
          if(res.data.code==200){
            var list=JSON.parse(JSON.stringify(res.data.data).replace(/name/g, 'text'));
            list=JSON.parse(JSON.stringify(list).replace(/id/g, 'value'));
            this.columns[3].filters  = list
          }else if(res.data.code==300){
              this.$router.push({path: '/'})
          }else{
              Toast(res.data.msg)
          }
      })

      // 流量类型
      this.$axios.get("/api/getflowtype",{
          headers:{
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
      }).then((res)=> {
          if(res.data.code==200){
            var list=JSON.parse(JSON.stringify(res.data.data).replace(/name/g, 'text'));
            list=JSON.parse(JSON.stringify(list).replace(/id/g, 'value'));
            this.columns[2].filters  = list
          }else if(res.data.code==300){
              this.$router.push({path: '/'})
          }else{
              Toast(res.data.msg)
          }
      })

      // 流量趋势
      this.$axios.get("/api/flowtop10",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
          kind:this.kind
        }
      }).then((res)=> {
        if(res.data.code==200){
          var num=res.data.data.count
          var width=(400/num)-10
          this.flowtop10xwidth=width
            console.log("width="+num)
          console.log("flowtop10xwidth="+this.flowtop10xwidth)
          this.flowtop10x=res.data.data.xstr
          this.flowtop10x= eval('(' +  this.flowtop10x + ')');
          this.flowtop10y=res.data.data.ystr
          this.flowtop10y= eval('(' +  this.flowtop10y + ')');
          this.drawLine();
        }
      })

      // 流量来源比重
      this.$axios.get("/api/flowsource",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
        }
      }).then((res)=> {
        if(res.data.code==200){
          this.flowsourcex=res.data.data.sourcestr
          this.flowsourcex = this.flowsourcex.replace(/'/g, '"');
          this.flowsourcex=JSON.parse(this.flowsourcex);
          this.flowsourcey=res.data.data.browstr
          this.flowsourcey = this.flowsourcey.replace(/'/g, '"');
          this.flowsourcey=JSON.parse(this.flowsourcey);
          var obj=[]
          for(var i in this.flowsourcex ){
            obj.push({name:this.flowsourcex[i],value:this.flowsourcey[i]});
          }
          obj=JSON.stringify( obj )
          this.flowsourcey= eval('(' +  obj + ')');
          this.drawLine();
        }
      })

      this.drawLine();
    },
    
    changeflowsource(e){
      var changesource=e.target.value;
      this.$axios.get("/api/flowsource",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
        }
      }).then((res)=> {
        if(res.data.code==200){
          this.flowsourcex=res.data.data.sourcestr
          this.flowsourcex = this.flowsourcex.replace(/'/g, '"');
          this.flowsourcex=JSON.parse(this.flowsourcex);

          var obj=[]
          if(changesource==1){
            this.flowsourcey=res.data.data.browstr
            this.flowsourcey = this.flowsourcey.replace(/'/g, '"');
            this.flowsourcey=JSON.parse(this.flowsourcey);
          }else if(changesource==2){
            this.flowsourcey=res.data.data.ipstr
            this.flowsourcey = this.flowsourcey.replace(/'/g, '"');
            this.flowsourcey=JSON.parse(this.flowsourcey);
          }else if(changesource==3){
            this.flowsourcey=res.data.data.uipstr
            this.flowsourcey = this.flowsourcey.replace(/'/g, '"');
            this.flowsourcey=JSON.parse(this.flowsourcey);
          }
          for(var i in this.flowsourcex ){
            obj.push({name:this.flowsourcex[i],value:this.flowsourcey[i]});
          }
          obj=JSON.stringify( obj )
          this.flowsourcey= eval('(' +  obj + ')');
          this.drawLine();
        
        }
      })
    },

    handleTableChange(pagination, filters, sorter) {
      console.log(pagination);
      const pager = { ...this.pagination };
      pager.current = pagination.current;
      this.pagination = pager;
      
      this.fetch({
        limits: pagination.pageSize,
        page: pagination.current,
        sortField: sorter.field,
        sortorder: sorter.order,
        end_time:this.end_time,
        start_time:this.start_time,
        ...filters,

      });
    },

    
    fetch(params = {}) {

        params=JSON.parse(JSON.stringify(params).replace(/sourcestr/g, 'source'));
        params=JSON.parse(JSON.stringify(params).replace(/typestr/g, 'type'));
        
        if(params.source){
        
            params.source=params.source[0]
        }else{
          params.source=""
        }
        if(params.type){
            params.type=params.type[0]
        }else{
          params.type=""
        }

        this.loading = true;
        this.$axios.get('/api/flowlist',{
            headers: {
                "appid": this.appSet.appid,
                "appkey": this.appSet.appkey,
                "token":localStorage.getItem('token'),
            },
            params:{
                end_time:this.end_time,
                start_time:this.start_time,
                limits: 10,
                ...params,
            }
        }).then((res)=>{
            if(res.data.code==200){
                const pagination = { ...this.pagination };
                pagination.total = res.data.data.count;
                var data=res.data.data.lists
                if(data.length>0){
                  for(var i in data){
                    data[i].ip=data[i].province+data[i].area+" "+data[i].ip
                  }
                }
                
                // console.log("info="+data[0].ip)
                this.data=data
                this.loading = false;
                this.pagination = pagination;
                
            }else if(res.data.code==300){
                this.$router.push({path: '/'})
            }else if(res.data.code==401){
                this.$message.warning(res.data.msg); 
            }else{
                this.$message.warning(res.data.msg); 
            }
        })

    },

    onChange(date, dateString) {
      console.log("date"+dateString);
      this.qdate=dateString
    },


    drawLine(){
      var weightChart = this.$echarts.init(document.getElementById("weightChart"))
      weightChart.setOption({
        title: {
          text: '流量来源比重',
          textStyle: {
            fontWeight: 'normal',
          }
        },
        tooltip: {
        trigger: 'item',
        formatter:function (params) {
          var color = params.color;//图例颜色
          var htmlStr ='<div>';
          htmlStr += params.name + '<br/>';//x轴的名称
          //为了保证和原来的效果一样，这里自己实现了一个点的效果
          htmlStr += '<span style="margin-right:12px;height:8px;width:8px;border-radius:50%;display:inline-block;background:'+color+'"></span>';
          
          //添加一个汉字，这里你可以格式你的数字或者自定义文本内容
          htmlStr += params.name + '：'+params.value;
          
          htmlStr += '</div>';
          
          return htmlStr;
          },
          backgroundColor:'#fff',	
          textStyle: {
            color: "#666",
          },

          extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
        },
        legend: {
            icon: "circle", 
            itemWidth: 10, 
            itemHeight: 10,
            orient: 'vertical',
            right: 10,
            bottom:120,
            data: this.flowsourcex
        },
        series: [
          {
            type: 'pie',
            radius: ['40%', '60%'],
            avoidLabelOverlap: false,
            label: {
                show: false,
                position: 'center'
            },
            emphasis: {
                label: {
                    show: true,
                    fontSize: '30',
                    fontWeight: 'bold'
                }
            },
            labelLine: {
                show: false
            },
            // data: [
            //   {value: 1548, name: '百度搜索'},
            //   {value: 1310, name: '手机百度'},
            //   {value: 234, name: '360搜索'},
            //   {value: 135, name: '手机360'},
            //   {value: 135, name: '搜狗搜索'},
            //   {value: 248, name: '手机搜狗'},
            //   {value: 335, name: '其他'}
            // ],
              data:this.flowsourcey,
              itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = ["#709af3", "#64ddae", "#f6b23f", "#ea6a65", "#7aceea",
                      "#a16dbc", "#749c51"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }
        ]
      });

      var areaChart = this.$echarts.init(document.getElementById("areaChart"))
      areaChart.setOption({
        title: {
          text: '流量区域TOP10',
          textStyle: {
            fontWeight: 'normal',
          }
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {            
              type: 'shadow' 
          },
          backgroundColor:'#fff',	
          textStyle: {
            color: "#666" //设置文字颜色
          },

        },
        grid: {
            left: '0%',
            right: '8%',
            bottom: '3%',
            containLabel: true
        },
        xAxis: [
            {   
              type: 'category',
              data: this.flowtop10x,
              axisTick: {
                  alignWithLabel: true
              },
              axisLabel:{
                interval:0,
              }
            }
        ],
        yAxis: [
            {
              type: 'value'
            }
        ],
        series: [
          {
            name: '流量',
            type: 'bar',
            barWidth: '60%',
            data: this.flowtop10y,
            barWidth: this.flowtop10xwidth,
            itemStyle: {
              normal: {
                //每根柱子颜色设置
                color: function (params) {
                  let colorList = ["#709af3", "#64ddae", "#f6b23f", "#ea6a65"
                  ];
                  return colorList[params.dataIndex];
                }
              }
            },
          }
        ]
      });

      var trendChart = this.$echarts.init(document.getElementById("trendChart"))
        this.$axios.get("/api/flowtrend",{
          headers:{
              "appid": this.appSet.appid,
              "appkey": this.appSet.appkey,
              "token":localStorage.getItem('token'),
          },
          params:{
            end_time:this.end_time,
            start_time:this.start_time,
          }
        }).then((res)=> {
          if(res.data.code==200){
            this.flowtrendx=res.data.data.xstr
            this.flowtrendx= eval('(' +  this.flowtrendx + ')');
            this.flowtrendy=res.data.data.ystr
            this.flowtrendy= eval('(' +  this.flowtrendy + ')');
            trendChart.setOption({
            title: {
              text: '流量趋势图',
              textStyle: {
                fontWeight: 'normal',
              }
            },
            color:'#709af3',
              tooltip: {
              trigger: 'axis',
              axisPointer: {            
                  type: 'line' 
              },
              backgroundColor:'#fff',	
              textStyle: {
                color: "#666" //设置文字颜色
              },
              extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
            },
            grid: {
              left: '2%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              // data: ['00时', '02时', '04时', '06时', '08时', '10时', '12时', '14时', '16时', '18时', '20时', '22时']
              data:this.flowtrendx
            },
            
            yAxis: {
              type: 'value'
            },
            series: [{
              name: '数量',
              // data: [20, 32, 61, 34, 12, 30, 10,0,0,0,0,0],
              data:this.flowtrendy,
              type: 'line',
              areaStyle: {
                color:'#709af3',
                opacity:0.4
              }
            }]
          });
        }
      })



      var useIPChart = this.$echarts.init(document.getElementById("useIPChart"))
      var trendChart = this.$echarts.init(document.getElementById("trendChart"))
      this.$axios.get("/api/uiptrend",{
        headers:{
            "appid": this.appSet.appid,
            "appkey": this.appSet.appkey,
            "token":localStorage.getItem('token'),
        },
        params:{
          end_time:this.end_time,
          start_time:this.start_time,
        }
      }).then((res)=> {
          this.uiptrendx=res.data.data.xstr
          this.uiptrendx= eval('(' +  this.uiptrendx + ')');
          this.uiptrendy=res.data.data.ystr
          this.uiptrendy= eval('(' +  this.uiptrendy + ')');
        if(res.data.code==200){
          useIPChart.setOption({
            title: {
              text: '有效IP走势图',
              textStyle: {
                fontWeight: 'normal',
              }
            },
            color:'#709af3',
              tooltip: {
              trigger: 'axis',
              axisPointer: {            
                  type: 'line' 
              },
              backgroundColor:'#fff',	
              textStyle: {
                color: "#666" //设置文字颜色
              },
              extraCssText: 'box-shadow: 0 0 7px rgba(0, 0, 0, 0.5);'
            },
            grid: {
              left: '2%',
              right: '4%',
              bottom: '3%',
              containLabel: true
            },
            xAxis: {
              type: 'category',
              boundaryGap: false,
              data: this.uiptrendx
            },
            
            yAxis: {
              type: 'value'
            },
            series: [{
              name: '数量',
              data: this.uiptrendy,
              type: 'line',
              areaStyle: {
                color:'#709af3',
                opacity:0.4
              }
            }]
          });
        }

      })
   


    }
  }
}
</script>




// WEBPACK FOOTER //
// src/components/analysis/index.vue